
(function($s){

	$.isMobile = function(type){
        let reg = [];
        const any = {
            blackberry: 'BlackBerry',
            android: 'Android',
            windows: 'IEMobile',
            opera: 'Opera Mini',
            ios: 'iPhone|iPad|iPod'
        };
        type = 'undefined' === $.type(type) ? '*' : type.toLowerCase();
        if ('*' === type) reg = $.map(any, function(v){ return v; });
        else if (type in any) reg.push(any[type]);
        return !!(reg.length && navigator.userAgent.match(new RegExp(reg.join('|'), 'i')));
    };

	$.inspect = function() {
		$('html.no-js').removeClass('no-js').addClass('js');
		$('html').addClass( $.isMobile() ? 'mobile' : 'desktop' );
	}

	$.isScrolled = function() {
        const _scrollTop = $(window).scrollTop();
        const _scrollOffset = 0;
        let _html = $('html');

        _scrollTop	? $(_html).addClass('scrolled').attr('data-scroll-top', _scrollTop)
					: $(_html).removeClass('scrolled').attr('data-scroll-top', 0);

		_scrollOffset < _scrollTop ?  $(_html).addClass('scroll-hide') : $(_html).removeClass('scroll-hide');

		return ($(_html).hasClass('scrolled'));
	}

	$.activateToggle = function() {
        const _toggleLinks = $('[data-toggle="toggle"]');

        $.each( $(_toggleLinks), function(i, v) {
            const _target = $(this).attr('data-target');

            $(this).bind('click', function(e) {
				$.toggleItem(_target);
			});

		});
	}

    function pageLoaded() {
        $.inspect();
        $.isScrolled();
        $.activateToggle();

        $('a[data-rel]').each(function() {$(this).attr('rel', $(this).data('rel'));});
        $('[data-toggle="tooltip"]').tooltip({html:true});

        let responsiveTable = $('.table-responsive');
        $(responsiveTable).on('show.bs.dropdown', function () {
            $('.table-responsive').css( "overflow", "inherit" );
        });

        $(responsiveTable).on('hidden.bs.dropdown', function () {
            setTimeout(function () {
                $('.table-responsive').css( "overflow", "auto" );
            }, 500);
        })

        //console.log('loaded ui-base');
    };

    // add livewire navigated listener
    document.addEventListener('livewire:navigated', function () {
        pageLoaded();
    });

    // livewire is not installed
    if (typeof Livewire === "undefined") {
        // do jquery basic stuff after page has loaded
        $(function(){
            pageLoaded();
        });
    }

	$._debounce = function debounce(func, wait, immediate) {
        let timeout;
        return function() {
            const context = this,
                args = arguments;
            const later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
			timeout = setTimeout(later, wait || 100);
			if (callNow) func.apply(context, args);
		};
	};

	$.toggleItem = function(toggleItem, isPerClick) {
        const _toggleLinks = $('[data-target="' + toggleItem + '"]');

        if(typeof isPerClick == 'undefined') {
			isPerClick = true;
		}

		if( $(toggleItem).is(':visible') ) {
			$.each( $(_toggleLinks), function(i, v) {
				if( $(this).attr('data-toggle')==='toggle') {$(this).removeClass('active')}
			});
			$(toggleItem).animate({ 'opacity': '0'}, 500, function() {
				$(toggleItem).removeClass('in').css('display', 'none');
			});
		}
		else {
			$.each( $(_toggleLinks), function(i, v) {
				if( $(this).attr('data-toggle')==='toggle') {$(this).addClass('active')}
			});
			$(toggleItem).css('opacity', '0').css('display', ($(toggleItem).attr('data-display') ? $(toggleItem).attr('data-display') : 'block'));
			$(toggleItem).animate({ 'opacity': '1'}, 500, function() {
				$(toggleItem).addClass('in');
			});
		}
	};

}( jQuery ));

const _baseScrollDebouncingHandler = $._debounce(function (e) {
    $.isScrolled();
}, 100);

const _baseResizeDebouncingHandler = $._debounce(function (e) {
    $.isScrolled();
}, 100);

$(window).bind('scroll', function(e) { _baseScrollDebouncingHandler(e); });
$(window).bind('resize', function(e) { _baseResizeDebouncingHandler(e); });
